<template>
  <div>
    <v-toolbar color="background darken-1" flat>
      <v-toolbar-title v-bind:class="moveTitleClassObject"
        >Items en Tránsito
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text dark mediun color="secondary" @click="loadData()">
        <v-icon dark>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
      <excell
        :items="items"
        :headers="xlsxHeaders"
        :fieldValues="xlsxFields"
      ></excell>

      <template v-slot:extension>
        <v-tabs
          align-with-title
          v-model="tab"
          slider-color="transparent"
          active-class="background base"
        >
          <v-tab href="#tab-1">
            <v-badge
              inline
              :content="items.length"
              :value="items.length"
              color="primary"
              transition="scale-transition"
            >
              Mis Cpc´s
            </v-badge>
          </v-tab>

          <v-tab href="#tab-2">
            <v-badge
              inline
              :content="otrosItems.length"
              :value="otrosItems.length"
              color="primary"
              transition="scale-transition"
            >
              Otros Cpc´s
            </v-badge>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-container fluid grid-list-lg>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="agg"></resume>
            </v-col>
          </v-row>

          <!--           <v-row>
            <v-col>
              <v-alert
                v-model="showMoreItems"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="scale-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    Se han encontrado más resultados que coinciden con su
                    criterio de búsqueda en "Descripción de la compra" en otros
                    códigos CPC´s que no constan en su Registro Único de
                    Proveedor (RUP).</v-col
                  >
                  <v-col class="shrink">
                    <v-dialog
                      v-model="dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="secondary" v-on="on">VER ITEMS</v-btn>
                      </template>
                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Otros Items</v-toolbar-title>
                          <div class="flex-grow-1"></div>
                          <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                              >Cerrar</v-btn
                            >
                          </v-toolbar-items>
                        </v-toolbar>
                        <resume
                          :isLoading="loading"
                          :agg="aggOtros"
                          class="mt-2"
                        ></resume>
                        <v-row>
                          <v-col>
                            <transito-table
                              :items="otrosItems"
                              :loading="loading"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col>
              <transito-table :items="items" :loading="loading" />
              <v-alert
                v-if="totalItems > 1000 && items.length != totalItems"
                class="mt-4"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="fade-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    De forma predeterminada, las búsquedas devuelven los 1.000
                    primeros resultados de la búsqueda. Si desea navegar a
                    través de un conjunto de datos más grande puede dar clic en
                    <strong>CARGAR MÁS DATOS</strong> hasta alcanzar el valor
                    establecido en Items Planificados, pero tenga en cuenta que
                    esta operación puede aumentar significativamente el uso de
                    la memoria y la CPU, lo que resulta en un rendimiento
                    degradado.
                  </v-col>
                  <v-col class="shrink">
                    <v-btn
                      block
                      v-on:click="loadMore()"
                      color="secondary"
                      :loading="loadingMoreBtn"
                    >
                      CARGAR MÁS DATOS
                      <template v-slot:loader>
                        <v-progress-circular
                          :size="18"
                          :width="2"
                          indeterminate
                          class="mr-1"
                        ></v-progress-circular>
                        <span>{{ $Amplify.I18n.get("Wait...") }}</span>
                      </template>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item value="tab-2">
          <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="aggOtros"></resume>
            </v-col>
          </v-row>

          <!--           <v-row>
            <v-col>
              <v-alert
                v-model="showMoreItems"
                icon="mdi-lightbulb-outline"
                prominent
                border="left"
                text
                color="primary"
                transition="scale-transition"
              >
                <v-row align="center">
                  <v-col class="grow">
                    Se han encontrado más resultados que coinciden con su
                    criterio de búsqueda en "Descripción de la compra" en otros
                    códigos CPC´s que no constan en su Registro Único de
                    Proveedor (RUP).</v-col
                  >
                  <v-col class="shrink">
                    <v-dialog
                      v-model="dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="secondary" v-on="on">VER ITEMS</v-btn>
                      </template>
                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Otros Items</v-toolbar-title>
                          <div class="flex-grow-1"></div>
                          <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                              >Cerrar</v-btn
                            >
                          </v-toolbar-items>
                        </v-toolbar>
                        <resume
                          :isLoading="loading"
                          :agg="aggOtros"
                          class="mt-2"
                        ></resume>
                        <v-row>
                          <v-col>
                            <transito-table
                              :items="otrosItems"
                              :loading="loading"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col>
              <transito-table :items="otrosItems" :loading="loading" />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>

      <!--       <v-row>
        <v-col>
          <span
            class="headline font-weight-regular"
            v-bind:class="moveTitleClassObject"
          >
            Dashboard
            <v-icon>mdi-chevron-double-right</v-icon>
            Items en Transito
          </span></v-col
        >
        <v-col md="auto">
          <v-btn text dark mediun color="secondary" @click="loadData()">
            <v-icon dark>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
          <excell
            :items="items"
            :headers="xlsxHeaders"
            :fieldValues="xlsxFields"
          ></excell>
        </v-col>
      </v-row> -->

      <!--  <v-row no-gutters>
        <v-col>
          <v-alert
            dense
            icon="mdi-information-outline"
            border="left"
            class="py-0"
          >
            Esta vista contiene los items que se encuentran publicados en el
            portal de compras públicas que tiene cronograma vigente o que aún no
            han sido adjudicados. Este es el mejor lugar para encontrar
            oportunidades de negocios en el sector público
          </v-alert>
        </v-col>
      </v-row> -->

      <!--       <v-row no-gutters>
        <v-col>
          <v-tabs v-model="tab" grow>
            <v-tab href="#tab-1">
              <v-badge
                inline
                :content="items.length"
                :value="items.length"
                color="primary"
              >
                Mis Cpc´s
              </v-badge>
            </v-tab>

            <v-tab href="#tab-2">
              <v-badge
                inline
                :content="otrosItems.length"
                :value="otrosItems.length"
                color="primary"
              >
                Otros Cpc´s
              </v-badge>
            </v-tab>

            <v-tab-item value="tab-1"> </v-tab-item>

            <v-tab-item value="tab-2"> </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import Excell from "@/components/Excell";
import TransitoTable from "./components/TransitoTable";
import Resume from "@/components/Resume";

export default {
  name: "Transito",
  components: {
    Excell,
    Resume,
    TransitoTable
  },
  data() {
    return {
      tab: null,
      snackbar: false,
      snackbarText: "",
      loading: false,
      loadingMoreBtn: false,
      from: 0,
      agg: [],
      aggOtros: [],
      items: [],
      otrosItems: [],
      totalItems: 0,
      dialog: false,
      xlsxHeaders: [
        "AÑO",
        "PERIODO",
        "CODIGO PROCESO",
        "PROVEEDOR ADJUDICADO",
        "CONTRATANTE",
        "PROCEDIMIMIENTO",
        "TIPO COMPRA",
        "DESCRIPCION",
        "CPC NIVEL 5",
        "CPC NIVEL 9",
        "PROVINCIA",
        "CANTON",
        "CANTIDAD",
        "MEDIDA",
        "VALOR UNITARIO",
        "TOTAL"
      ],
      xlsxFields: [
        "ano",
        "periodo",
        "codigo_proceso",
        "nombre_proveedor",
        "nombre_entidad",
        "procedimiento",
        "pac_tipo",
        "descripcion",
        "descripcion_cpc",
        "descripcion_cpc_full",
        "provincia_entidad",
        "canton_entidad",
        "pac_cantidad",
        "pac_medida",
        "pac_costo_unitario",
        "pac_total"
      ],
      logger: {}
    };
  },
  computed: {
    ...mapGetters(["filters"]),
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    showMoreItems() {
      return this.otrosItems.length > 0 && !this.loading ? true : false;
    },

    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      }
    }
  },
  methods: {
    elasticResultPreprocessor: function(body) {
      return body.hits.hits.map(item =>
        Object.assign({}, item._source, { highlight: item.highlight })
      );
    },
    loadMore: async function() {
      this.from = this.from + 1000;
      this.loadingMoreBtn = true;
      await this.loadData(this.from);
      this.loadingMoreBtn = false;
    },
    loadData: async function(from = 0) {
      if (!this.loadingMoreBtn) {
        this.items = [];
        this.otrosItems = [];
        this.from = 0;
        this.totalItems = 0;
      }
      this.loading = true;
      try {
        let { agg, aggOtros, items, otrosItems } = await postDashboard(from);
        this.agg = agg;
        this.aggOtros = aggOtros ? aggOtros : [];
        this.totalItems = agg && agg[0] ? agg[0].doc_count : 0;
        if (!this.loadingMoreBtn) {
          this.items = this.elasticResultPreprocessor(items);
          this.otrosItems =
            otrosItems && otrosItems.hits
              ? this.elasticResultPreprocessor(otrosItems)
              : [];
        } else {
          this.items = [
            ...this.items,
            ...this.elasticResultPreprocessor(items)
          ];
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
